import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import style from "./Request.module.scss";
import { useSelector } from "react-redux";
import Header from "components/UIComponents/Header/Header";
import InnerTitleCont from "components/UIComponents/InnerTitleCont/InnterTitleState";
import Footer from "components/UIComponents/Footer/Footer";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ServiceMunicipal from "components/UIComponents/Municipal/ServiceMunicipal";
import moment from "moment";
import { Accordion, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { downloadAttachment } from "api/serviceAPI";
import {
  Attachment,
  Csv,
  Doc,
  Jpg,
  Mp3,
  Mp4,
  Pdf,
  Png,
  Text,
  Zip,
} from "components/UIComponents/FileIcons";
import Grid from "./../../components/UIComponents/Grid/index";
import { Column } from "devextreme-react/data-grid";
import { useHistory } from "react-router-dom";
import {
  GoogleMap,
  LoadScript,
  Marker,
  useLoadScript,
  useJsApiLoader,
  StandaloneSearchBox,
} from "@react-google-maps/api";

const ClientRequestInfo = () => {
  const { t, i18n } = useTranslation("common");
  const { user, clientProfiles } = useSelector((state) => state.user);
  const { requestId } = useParams();
  const history = useHistory();
  const [data, setData] = useState();
  const [notesState, setNotesState] = useState(0);
  const [attachmentState, setAttachmentState] = useState(0);
  const [invoicesState, setInvoicesState] = useState(0);
  const [resultsState, setResultsState] = useState(0);
  const [inspectionDataState, setInspectionDataState] = useState(0);
  const [stepsObj, setStepsObj] = useState({});

  const stepsNo = [1, 2, 3, 4, 5];
  let steps = [];
  let status = "Invoice_Status_Name_EN";
  if (i18n.language === "ar") {
    status = "Invoice_Status_Name_AR";
  }
  const [mapState, setMapState] = useState({
    position: {
      lat: 0,
      lng: 0,
    },
    center: {
      lat: 0,
      lng: 0,
    },
  });
  let zoom = 12;
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCBx-BN5uLwmFezDw0NeQs9xp_UcplHIzs",
    libraries: ["places"],
  });
  // const TASK_SUPPORT_TYPE_ID = {
  //     4: "1",
  //     5: "2",
  //     15: "3",
  // };

  useEffect(() => {
    getClientRequestInfo();
  }, []);

  useEffect(() => {
    if (data?.Requet_Inputs_Info?.length > 0) steps.push("notes");
    if (data?.Requet_Attachments_Info?.length > 0) steps.push("attachments");
    if (data?.Requet_Invoices_Info?.length > 0) steps.push("invoices");
    if (data?.Requet_Results_Info?.length > 0) steps.push("results");
    if (data?.Visit_Data_Info !== null) steps.push("inspectionData");
    setStepsObj(
      steps.reduce(
        (obj, steps, index) => ({ ...obj, [steps]: stepsNo[index] }),
        {}
      )
    );
  }, [data]);

  const getClientRequestInfo = async () => {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/PORTAL/CLIENTS/REQUESTS/GET_CLIENT_REQUEST_INFO`,
      {
        Client_Profile_Id: clientProfiles?.Client_Profile_Id,
        Request_Id: requestId,
        Info_Type: "0",
      },
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    setData(res.data.Data);
  };

  const download = async (f) => {
    await downloadAttachment({
      File_Code: f.File_Code,
    })
      .then(function (response) {
        const blob = new Blob([response]);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", f.File_Name);
        // document.body.appendChild(link);
        link.click();
      })
      .catch((ex) => {
        console.error(ex);
      });
  };

  return (
    <>
      <Header />

      {data ? (
        <>
          <InnerTitleCont
            breadCrumbs={`${t("menu_home")} / ${t("request_service_data")}`}
            title={`
                            ${data?.Request_Info?.Service_Code}/${i18n.language === "en"
                ? data?.Request_Info?.Service_Name_EN
                : data?.Request_Info?.Service_Name_AR
              }/${data?.Request_Info?.Department_Service_Version_Name}
                            <br/><br/>
                            ${data?.Request_Info?.Request_No}
                        `}
            permissionId={{ dealingTypeId: clientProfiles?.Dealing_Type_Id }}
            startBtn={false}
            leaveBtn={true}
            // startTrigger={isAuthenticated ? handleRequestStart : modalShow}
            leaveTrigger={() => window.history.back()}
          />

          <Container fluid="lg" className="pageContainer">
            <Row className="mb-5">
              <Col md={8}>
                <div className="gCard">
                  <Row className="align-items-center position-relative">
                    <Col xs={6}>
                      <p className={style.title}>{t("request_service_info")}</p>
                    </Col>

                    <Col xs={6} className="d-flex justify-content-end mb-2">
                      <button
                        className="mainBtn primarymainBtn smBtn"
                        onClick={() => window.history.back()}
                      >
                        {t("close")}
                      </button>
                    </Col>
                  </Row>

                  <Row className="align-items-center position-relative">
                    <Col xs={12} className={style.detailsContent}>
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("Request Number")}
                            </p>
                            <p className={style.details}>
                              {data?.Request_Info?.Request_No}
                            </p>
                          </Row>
                        </Col>

                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("Request Date")}:
                            </p>
                            <p className={style.details}>
                              {data?.Request_Info?.Request_Date &&
                                moment(data?.Request_Info?.Request_Date)
                                  .lang("en")
                                  .format("YYYY-MM-DD")}
                            </p>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <Row className="flex-nowrap">
                            <p className={style.details}>
                              {t("service_name")}:
                            </p>
                            <p className={style.details}>
                              {i18n.language === "ar"
                                ? data?.Request_Info?.Service_Name_AR
                                : data?.Request_Info?.Service_Name_EN}
                            </p>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("department_name")}:
                            </p>
                            <p className={style.details}>
                              {i18n.language === "ar"
                                ? data?.Request_Info?.Department_Name_AR
                                : data?.Request_Info?.Department_Name_EN}
                            </p>
                          </Row>
                        </Col>

                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("dealing_type")}:
                            </p>
                            <p className={style.details}>
                              {i18n.language === "ar"
                                ? data?.Request_Info?.Dealing_Type_Name_AR
                                : data?.Request_Info?.Dealing_Type_Name_EN}
                            </p>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("Service Version")}:
                            </p>
                            <p className={style.details}>
                              {
                                data?.Request_Info
                                  ?.Department_Service_Version_Name
                              }
                            </p>
                          </Row>
                        </Col>

                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("service_code")}:
                            </p>
                            <p className={style.details}>
                              {data?.Request_Info?.Service_Code}
                            </p>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("request_status")}:
                            </p>
                            <p className={style.details}>
                              {i18n.language === "ar"
                                ? data?.Request_Info?.Request_Status_Name_AR
                                : data?.Request_Info?.Request_Status_Name_EN}
                            </p>
                          </Row>
                        </Col>

                        <Col xs={6}>
                          <Row>
                            <p className={style.details}>
                              {t("Service Category")}:
                            </p>
                            <p className={style.details}>
                              {i18n.language === "ar"
                                ? data?.Request_Info?.Service_Category_Name_AR
                                : data?.Request_Info?.Service_Category_Name_EN}
                            </p>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        {data?.Request_Info?.Department_Service_Step_Name_AR ||
                          data?.Request_Info?.Department_Service_Step_Name_EN ? (
                          <Col xs={6}>
                            <Row>
                              <p className={style.details}>
                                {t("current_request_status")}:
                              </p>
                              <p className={style.details}>
                                {i18n.language === "ar"
                                  ? data?.Request_Info
                                    ?.Department_Service_Step_Name_AR
                                  : data?.Request_Info
                                    ?.Department_Service_Step_Name_EN}
                              </p>
                            </Row>
                          </Col>
                        ) : null}

                        {data?.Request_Info?.End_Request_Date ? (
                          <Col xs={6}>
                            <Row>
                              <p className={style.details}>
                                {t("end_request_date")}:
                              </p>
                              <p className={style.details}>
                                {data?.Request_Info?.End_Request_Date &&
                                  moment(data?.Request_Info?.End_Request_Date)
                                    .lang("en")
                                    .format("YYYY-MM-DD")}
                              </p>
                            </Row>
                          </Col>
                        ) : null}

                        {data?.Request_Info?.Inspection_Time ? (
                          <Col xs={6}>
                            <Row>
                              <p className={style.details}>
                                {t("Inspection_date")}:
                              </p>
                              <p className={style.details}>
                                {data?.Request_Info?.Inspection_Time &&
                                  moment(data?.Request_Info?.Inspection_Time)
                                    .lang("en")
                                    .format("YYYY-MM-DD")}
                              </p>
                            </Row>
                          </Col>
                        ) : null}

                        {data?.Request_Info?.Request_Reject_Reasons ? (
                          <Col xs={12}>
                            <Row>
                              <p className={style.details}>
                                {t("request_reject_reasons")}:
                              </p>
                              <p className={style.details}>
                                {data?.Request_Info?.Request_Reject_Reasons}
                              </p>
                            </Row>
                          </Col>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>

                  {stepsObj["notes"] ? (
                    <Row>
                      <Col>
                        <Accordion activeKey={notesState}>
                          <Card className={style.accCard}>
                            <Card.Header className={style.accHeader}>
                              <Accordion.Toggle
                                eventKey={notesState}
                                className={style.accBtn}
                                onClick={() =>
                                  setNotesState(notesState == 0 ? 1 : 0)
                                }
                              >
                                <Row className="align-items-center position-relative">
                                  <Col
                                    xs={6}
                                    className={[style.step, "mb-0"].join(" ")}
                                  >
                                    <div className={style.stepHeader}>
                                      <span className={style.number}>
                                        {stepsObj["notes"]}
                                      </span>
                                      <p className={style.stepTitle}>
                                        {t("service_request_notes")}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col
                                    xs={6}
                                    className="d-flex justify-content-end mb-2"
                                  >
                                    <span
                                      className={[
                                        style.accArrow,
                                        notesState == 1 ? style.upArrow : null,
                                      ].join(" ")}
                                    >
                                      <svg
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="451.847px"
                                        height="451.847px"
                                        viewBox="0 0 451.847 451.847"
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                                                                                        c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                                                                                        c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </Col>
                                </Row>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={notesState}>
                              <Row className="align-items-center position-relative">
                                <Card.Body className="pt-0">
                                  <Col xs={12} className={style.detailsContent}>
                                    <Row>
                                      {data?.Requet_Inputs_Info.map(
                                        (input, index) => (
                                          <Col
                                            xs={
                                              input.Input_Type == 1
                                                ? 6
                                                : input.Input_Type == 2
                                                  ? 12
                                                  : false
                                            }
                                            key={index}
                                          >
                                            <Form.Label
                                              className={
                                                style.clientRequestLabel
                                              }
                                            >
                                              {i18n.language == "en"
                                                ? input.Input_Title_EN
                                                : input.Input_Title_AR}
                                            </Form.Label>
                                            <Form.Control
                                              className="my-1"
                                              as={
                                                input.Input_Type == 2
                                                  ? "textarea"
                                                  : "input"
                                              }
                                              rows={3}
                                              defaultValue={input.Input_Value}
                                              disabled
                                            />
                                          </Col>
                                        )
                                      )}
                                    </Row>
                                  </Col>
                                </Card.Body>
                              </Row>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  ) : null}

                  {stepsObj["attachments"] ? (
                    <Row>
                      <Col>
                        <Accordion activeKey={attachmentState}>
                          <Card className={style.accCard}>
                            <Card.Header className={style.accHeader}>
                              <Accordion.Toggle
                                eventKey={attachmentState}
                                className={style.accBtn}
                                onClick={() =>
                                  setAttachmentState(
                                    attachmentState == 0 ? 1 : 0
                                  )
                                }
                              >
                                <Row className="align-items-center position-relative">
                                  <Col
                                    xs={6}
                                    className={[style.step, "mb-0"].join(" ")}
                                  >
                                    <div className={style.stepHeader}>
                                      <span className={style.number}>
                                        {stepsObj["attachments"]}
                                      </span>
                                      <p className={style.stepTitle}>
                                        {t("service_request_attachments")}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col
                                    xs={6}
                                    className="d-flex justify-content-end mb-2"
                                  >
                                    <span
                                      className={[
                                        style.accArrow,
                                        attachmentState == 1
                                          ? style.upArrow
                                          : null,
                                      ].join(" ")}
                                    >
                                      <svg
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="451.847px"
                                        height="451.847px"
                                        viewBox="0 0 451.847 451.847"
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                                                                                        c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                                                                                        c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </Col>
                                </Row>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={attachmentState}>
                              <Row className="align-items-center position-relative">
                                <Card.Body className="pt-0">
                                  <Col xs={12} className={style.detailsContent}>
                                    <Row>
                                      {data?.Requet_Attachments_Info?.map(
                                        (input, index) => (
                                          <Col
                                            xs={12}
                                            key={index}
                                            className="my-2"
                                          >
                                            <Row>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {i18n.language == "en"
                                                  ? input.Att_Title_EN
                                                  : input.Att_Title_AR}
                                              </Form.Label>
                                            </Row>

                                            <Row className="justify-content-between">
                                              {input.Att_Files.map(
                                                (file, index) => (
                                                  <div
                                                    className="my-2 d-flex"
                                                    key={index}
                                                  >
                                                    <div className="d-flex">
                                                      {getFileIcon(
                                                        file.File_Type
                                                      )}
                                                      <span
                                                        className={[
                                                          style.fileContent,
                                                          style.clientRequestInfo,
                                                          "mx-1",
                                                        ].join(" ")}
                                                      >
                                                        {file.File_Name}
                                                      </span>
                                                      <span
                                                        className={[
                                                          style.fileContent,
                                                          "mx-1",
                                                        ].join(" ")}
                                                      >
                                                        {file.File_Size}
                                                      </span>
                                                    </div>

                                                    <div className="d-flex">
                                                      <FontAwesomeIcon
                                                        className="mx-1"
                                                        size="1x"
                                                        color={"#1e90ff"}
                                                        icon={faDownload}
                                                        onClick={() =>
                                                          download(file)
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </Row>
                                          </Col>
                                        )
                                      )}
                                    </Row>
                                  </Col>
                                </Card.Body>
                              </Row>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  ) : null}

                  {stepsObj["invoices"] ? (
                    <Row>
                      <Col>
                        <Accordion activeKey={invoicesState}>
                          <Card className={style.accCard}>
                            <Card.Header className={style.accHeader}>
                              <Accordion.Toggle
                                eventKey={invoicesState}
                                className={style.accBtn}
                                onClick={() =>
                                  setInvoicesState(invoicesState == 0 ? 1 : 0)
                                }
                              >
                                <Row className="align-items-center position-relative">
                                  <Col
                                    xs={6}
                                    className={[style.step, "mb-0"].join(" ")}
                                  >
                                    <div className={style.stepHeader}>
                                      <span className={style.number}>
                                        {stepsObj["invoices"]}
                                      </span>
                                      <p className={style.stepTitle}>
                                        {t("service_request_invoices")}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col
                                    xs={6}
                                    className="d-flex justify-content-end mb-2"
                                  >
                                    <span
                                      className={[
                                        style.accArrow,
                                        invoicesState == 1
                                          ? style.upArrow
                                          : null,
                                      ].join(" ")}
                                    >
                                      <svg
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="451.847px"
                                        height="451.847px"
                                        viewBox="0 0 451.847 451.847"
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                                                                                        c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                                                                                        c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </Col>
                                </Row>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={invoicesState}>
                              <Row className="align-items-center position-relative">
                                <Card.Body className="pt-0">
                                  <Col xs={12}>
                                    {invoicesState ? (
                                      <Row>
                                        <Grid
                                          columnHidingEnabled={true}
                                          sourceData={
                                            data?.Requet_Invoices_Info
                                          }
                                          addEnabled={false}
                                          editEnabled={false}
                                          deleteEnabled={false}
                                          viewEnabled={true}
                                          onView={({ data }) => {
                                            history.push({
                                              pathname: `/payments-view/${data?.Invoice_Id}`,
                                              state: { data: data },
                                            });
                                          }}
                                          onDelete={({ data }) => { }}
                                        >
                                          <Column
                                            caption={t("payment_no")}
                                            alignment="center"
                                            dataField="Payment_No"
                                            dataType="number"
                                            width={180}
                                          />
                                          <Column
                                            caption={t("date")}
                                            alignment="center"
                                            dataField="Invoice_Date"
                                            dataType="date"
                                            format="yyyy-MM-dd"
                                            width={100}
                                          />
                                          <Column
                                            caption={t("request_status")}
                                            alignment="center"
                                            dataField={status}
                                            dataType="string"
                                            width={100}
                                          />
                                          <Column
                                            caption={t(
                                              "invoice_detail_total_value"
                                            )}
                                            alignment="center"
                                            dataField="Invoice_Value"
                                            dataType="string"
                                          />
                                          <Column
                                            caption={t("invoice_payer")}
                                            alignment="center"
                                            dataField="Invoice_Payer_Name"
                                            dataType="string"
                                          />
                                        </Grid>
                                      </Row>
                                    ) : null}
                                  </Col>
                                </Card.Body>
                              </Row>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  ) : null}

                  {stepsObj["results"] &&
                    data.Request_Info.Request_Status_Id !== 0 ? (
                    <Row>
                      <Col>
                        <Accordion activeKey={resultsState}>
                          <Card className={style.accCard}>
                            <Card.Header className={style.accHeader}>
                              <Accordion.Toggle
                                eventKey={resultsState}
                                className={style.accBtn}
                                onClick={() =>
                                  setResultsState(resultsState == 0 ? 1 : 0)
                                }
                              >
                                <Row className="align-items-center position-relative">
                                  <Col
                                    xs={6}
                                    className={[style.step, "mb-0"].join(" ")}
                                  >
                                    <div className={style.stepHeader}>
                                      <span className={style.number}>
                                        {stepsObj["results"]}
                                      </span>
                                      <p className={style.stepTitle}>
                                        {t("service_request_results")}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col
                                    xs={6}
                                    className="d-flex justify-content-end mb-2"
                                  >
                                    <span
                                      className={[
                                        style.accArrow,
                                        resultsState == 1
                                          ? style.upArrow
                                          : null,
                                      ].join(" ")}
                                    >
                                      <svg
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="451.847px"
                                        height="451.847px"
                                        viewBox="0 0 451.847 451.847"
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                                                                                        c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                                                                                        c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </Col>
                                </Row>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={resultsState}>
                              <Row className="align-items-center position-relative">
                                <Card.Body className="pt-0">
                                  <Col xs={12} className={style.detailsContent}>
                                    <Row>
                                      {data?.Requet_Results_Info?.map(
                                        (file, index) => (
                                          <Col
                                            xs={12}
                                            key={index}
                                            className="my-2"
                                          >
                                            <Row className="justify-content-between">
                                              <div
                                                className="my-2 d-flex"
                                                key={index}
                                              >
                                                <div className="d-flex">
                                                  {getFileIcon(file.File_Type)}
                                                  <span
                                                    className={[
                                                      style.fileContent,
                                                      style.clientRequestInfo,
                                                      "mx-1",
                                                    ].join(" ")}
                                                  >
                                                    {file.File_Name}
                                                  </span>
                                                  <span
                                                    className={[
                                                      style.fileContent,
                                                      "mx-1",
                                                    ].join(" ")}
                                                  >
                                                    {file.File_Size}
                                                  </span>
                                                </div>

                                                <div className="d-flex">
                                                  <FontAwesomeIcon
                                                    className="mx-1"
                                                    size="1x"
                                                    color={"#1e90ff"}
                                                    icon={faDownload}
                                                    onClick={() =>
                                                      download(file)
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </Row>
                                          </Col>
                                        )
                                      )}
                                    </Row>
                                  </Col>
                                </Card.Body>
                              </Row>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  ) : null}

                  {stepsObj["inspectionData"] ? (
                    <Row>
                      <Col>
                        <Accordion activeKey={inspectionDataState}>
                          <Card className={style.accCard}>
                            <Card.Header className={style.accHeader}>
                              <Accordion.Toggle
                                eventKey={inspectionDataState}
                                className={style.accBtn}
                                onClick={() =>
                                  setInspectionDataState(
                                    inspectionDataState == 0 ? 1 : 0
                                  )
                                }
                              >
                                <Row className="align-items-center position-relative">
                                  <Col
                                    xs={6}
                                    className={[style.step, "mb-0"].join(" ")}
                                  >
                                    <div className={style.stepHeader}>
                                      <span className={style.number}>
                                        {stepsObj["inspectionData"]}
                                      </span>
                                      <p className={style.stepTitle}>
                                        {t("inspectionData")}
                                      </p>
                                    </div>
                                  </Col>

                                  <Col
                                    xs={6}
                                    className="d-flex justify-content-end mb-2"
                                  >
                                    <span
                                      className={[
                                        style.accArrow,
                                        inspectionDataState == 1
                                          ? style.upArrow
                                          : null,
                                      ].join(" ")}
                                    >
                                      <svg
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="451.847px"
                                        height="451.847px"
                                        viewBox="0 0 451.847 451.847"
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                                                                                        c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                                                                                        c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  </Col>
                                </Row>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={inspectionDataState}>
                              <Row className="align-items-center position-relative">
                                <Card.Body className="pt-0">
                                  <Col xs={12}>
                                    {inspectionDataState ? (
                                      <Row>
                                        <Col
                                          xs={12}
                                          className={style.detailsContent}
                                        >
                                          <Row>
                                            <Col xs={12} md={6}>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {t("inspectionTime")}
                                              </Form.Label>
                                              <Form.Control
                                                className="my-1"
                                                as={"input"}
                                                rows={3}
                                                defaultValue={
                                                  data.Visit_Data_Info
                                                    .Inspection_Time &&
                                                  moment(
                                                    data.Visit_Data_Info
                                                      .Inspection_Time
                                                  )
                                                    .lang("en")
                                                    .format("YYYY-MM-DD")
                                                  // .format(
                                                  //   i18n.language === "ar"
                                                  //     ? "HH:mm:ss YYYY-MM-DD"
                                                  //     : "YYYY-MM-DD HH:mm:ss"
                                                  // )
                                                }
                                                disabled
                                              />
                                            </Col>
                                            <Col xs={12} md={6}>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {t("inspectionUsername")}
                                              </Form.Label>
                                              <Form.Control
                                                className="my-1"
                                                as={"input"}
                                                rows={3}
                                                defaultValue={
                                                  i18n.language === "ar"
                                                    ? data.Visit_Data_Info
                                                      .Inspection_User_Name_AR
                                                    : data.Visit_Data_Info
                                                      .Inspection_User_Name_EN
                                                }
                                                disabled
                                              />
                                            </Col>
                                            <Col xs={12} md={6}>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {t("inspectionStartTime")}
                                              </Form.Label>
                                              <Form.Control
                                                className="my-1"
                                                as={"input"}
                                                rows={3}
                                                defaultValue={
                                                  data.Visit_Data_Info
                                                    .Inspection_Start_Time &&
                                                  moment(
                                                    data.Visit_Data_Info
                                                      .Inspection_Start_Time
                                                  )
                                                    .lang("en")
                                                    .format(
                                                      i18n.language === "ar"
                                                        ? "HH:mm:ss YYYY-MM-DD"
                                                        : "YYYY-MM-DD HH:mm:ss"
                                                    )
                                                }
                                                disabled
                                              />
                                            </Col>
                                            <Col xs={12} md={6}>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {t("inspectionEndTime")}
                                              </Form.Label>
                                              <Form.Control
                                                className="my-1"
                                                as={"input"}
                                                rows={3}
                                                defaultValue={
                                                  data.Visit_Data_Info
                                                    .Inspection_End_Time &&
                                                  moment(
                                                    data.Visit_Data_Info
                                                      .Inspection_End_Time
                                                  )
                                                    .lang("en")
                                                    .format(
                                                      i18n.language === "ar"
                                                        ? "HH:mm:ss YYYY-MM-DD"
                                                        : "YYYY-MM-DD HH:mm:ss"
                                                    )
                                                }
                                                disabled
                                              />
                                            </Col>
                                            <Col xs={12}>
                                              <Form.Label
                                                className={
                                                  style.clientRequestLabel
                                                }
                                              >
                                                {t("map")}
                                              </Form.Label>
                                              {isLoaded ? (
                                                <GoogleMap
                                                  mapContainerStyle={
                                                    containerStyle
                                                  }
                                                  center={{
                                                    lat: parseFloat(
                                                      data.Visit_Data_Info
                                                        .Inspection_latitudes
                                                    ),
                                                    lng: parseFloat(
                                                      data.Visit_Data_Info
                                                        .Inspection_longitudes
                                                    ),
                                                  }}
                                                  zoom={zoom}
                                                  defaultOptions={{
                                                    styles: stylesArr,
                                                  }}
                                                  options={{
                                                    styles: stylesArr,
                                                  }}
                                                >
                                                  <Marker
                                                    position={{
                                                      lat: parseFloat(
                                                        data.Visit_Data_Info
                                                          .Inspection_latitudes
                                                      ),
                                                      lng: parseFloat(
                                                        data.Visit_Data_Info
                                                          .Inspection_longitudes
                                                      ),
                                                    }}
                                                  />
                                                </GoogleMap>
                                              ) : (
                                                false
                                              )}
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    ) : null}
                                  </Col>
                                </Card.Body>
                              </Row>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Col>
                    </Row>
                  ) : null}

                  <Row className="mt-5 justify-content-end">
                    <Col className="d-flex justify-content-end mb-2">
                      <button
                        className="mainBtn primarymainBtn lgBtn"
                        onClick={() => window.history.back()}
                      >
                        {t("close")}
                      </button>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col md={4}>
                <div className="gCard">
                  <div className="text-center">
                    <ServiceMunicipal
                      municipalDetails={data?.Request_Info}
                      requestNo={data?.Request_Info?.Request_No}
                    // inputsData={currentTaskData?.Task_Type_Id === "5" ? currentTaskData : inputsData}
                    // supportTypeId={currentTaskData?.Task_Type_Id ? TASK_SUPPORT_TYPE_ID[currentTaskData.Task_Type_Id] : ""}
                    // isSupportEnabled={true}
                    // error={error}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </>
      ) : null}

      <Footer />
    </>
  );
};

export default ClientRequestInfo;

const getFileIcon = (fileType) => {
  return (
    {
      "image/jpeg": <Jpg />,
      "image/png": <Png />,
      "video/mp4": <Mp4 />,
      "application/pdf": <Pdf />,
      "application/vnd.ms-powerpoint": <Doc />,
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        <Doc />,
      "application/msword": <Doc />,
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        <Doc />,
      "audio/mpeg": <Mp3 />,
      "application/zip": <Zip />,
      "text/csv": <Csv />,
      "text/plain": <Text />,
    }[fileType] ?? <Attachment />
  );
};

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "12px",
};

const stylesArr = [
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [{ visibility: "simplified" }, { color: "#fdfdfd" }],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "landscape.natural.landcover",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "landscape.natural.landcover",
    elementType: "geometry.fill",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "landscape.natural.terrain",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "poi",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.attraction",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.business",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "poi.business",
    elementType: "geometry.fill",
    stylers: [{ hue: "#fcff00" }, { saturation: "0" }, { lightness: "40" }],
  },
  {
    featureType: "poi.government",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "#28a745" }],
  },
  {
    featureType: "poi.medical",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.school",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.sports_complex",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [{ color: "#000000" }],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ gamma: 7.18 }],
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: [
      { visibility: "on" },
      { saturation: "-35" },
      { lightness: "-95" },
      { gamma: "0.00" },
      { weight: "0.01" },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [{ color: "#baa167" }, { lightness: "40" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "#baa167" }, { lightness: "80" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "road.local",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ gamma: 0.48 }, { visibility: "off" }],
  },
  {
    featureType: "transit.station",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit.station.rail",
    elementType: "all",
    stylers: [{ visibility: "off" }, { color: "#ff0000" }],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [{ color: "#4d4946" }],
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      { visibility: "on" },
      { color: "#151713" },
      { lightness: "70" },
      { saturation: "0" },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffffff" }],
  },
];
